module.exports = __webpack_public_path__ + "static/img/15areaB_6.b5ca68c.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/15areaB_6.png
// module id = 1137
// module chunks = 1